import React from "react";

export const Appeals = () => {
  return <div className="font-bold text-5xl">Appeals</div>;
};
